export default {
	id: "ipad-air-2",
	title: "iPad Air 2",
	company: "Apple",
	colorSide: true,
	styles: [
		{
			title: "normal",
			pos: ["8.6%", "6%", "9.5%", "6%"],
			colors: [
				{title: "Gold", hex: "#DBC5AB", img: require("./original/gold.png")},
				{
					title: "Silver",
					hex: "#D5D2CF",
					img: require("./original/silver.png")
				},
				{
					title: "Space Grey",
					hex: "#9D9D9D",
					img: require("./original/space-grey.png")
				}
			]
		}
	]
};
